import { faLeaf } from '@fortawesome/free-solid-svg-icons';

import axios from 'axios';

import {IAllowBlockList} from '../shared/services/models/AllowBlockList';
import {IBoroSettings} from '../shared/services/models/BoroSettings';
import {IChangeLog} from '../shared/services/models/ChangeLog';
import {ICinegyRouteSource} from '../shared/services/models/CinegyRouteSource';
import {IEvent} from '../shared/services/models/Event';
import {IGeoIP} from '../shared/services/models/GeoIP';
import {IInterface, ITag} from '../shared/services/models/Interface';
import {ILicences, ILicenceRequest, ILicenceResponce} from '../shared/services/models/Licences';
import {INetwork} from '../shared/services/models/Network';
import {INetworkInterfaceHelper} from '../shared/services/models/Network';
import {IPlaylist, IPlaylists} from '../shared/services/models/Playlist';
import {IRecording} from '../shared/services/models/Recording';
import {IServer, ICommand, ICommandResponse} from '../shared/services/models/Server';
import {IService} from '../shared/services/models/Service';
import {ISetting} from '../shared/services/models/Setting';
import {IStatisticsSummary} from '../shared/services/models/StatisticsSummaries';
import {IStatus} from '../shared/services/models/Status';
import {IVersions} from '../shared/services/models/Versions';
import {IAccessControl} from '../shared/services/models/AccessControl';

class APIService {
    public async GetChangeLog(): Promise<IChangeLog> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            const changeLog: IChangeLog = {
                updated: '2023-11-20',
                services: [
                    {
                        name: 'UI',
                        versions: [
                            {
                                version: '1.6.4',
                                changes: [
                                    { type: 'enhancement', message: 'Added a download button for statistics for each interface.' },
                                    { type: 'enhancement', message: 'Support added for url encoded characters in passwords and settings' },
                                    { type: 'enhancement', message: 'Added loglevel for IDN Engine logs' },
                                    { type: 'bug', message: 'Fixed bug where Zixi username and pasword was overwritten when changing some parameters.'}
                                ],
                            },
                            {
                                version: '1.6.2',
                                changes: [
                                    { type: 'bug', message: 'Fixed issue where reboot button failed to reboot the server' },
                                    { type: 'bug', message: 'Fixed issue where restart interface sometimes fails to stop or start the interface' },
                                    { type: 'bug', message: 'Fixed issue where routing from an unicast input crashed the interface' },
                                    { type: 'enhancement', message: 'Route interface will now use the default NIC defined in settings for SRT inputs.'},
                                    { type: 'enhancement', message: 'New UI setting on SRT input for receive buffers'},
                                ],
                            },
                            {
                                version: '1.6.1',
                                changes: [
                                    { type: 'bug', message: 'Fixed bug where service status stopped updating after a while' },
                                ],
                            },
                            {
                                version: '1.6.0',
                                changes: [
                                    { type: 'enhancement', message: 'Added new setting for default nic, used when setting up srt,rist and zixi inputs/outputs' },
                                    { type: 'enhancement', message: 'Added now setting for "Always show network bindings", on the interfaces' },
                                    { type: 'enhancement', message: 'New fields for setting external IP address for each network, will be used for preview/quick links' },
                                    { type: 'enhancement', message: 'Adding new tag will now show a popup requesting name' },
                                    { type: 'enhancement', message: 'Adding new playlist will now show a popup requesting name' },
                                    { type: 'enhancement', message: 'Adding new allow-/blocklist will now show a popup requesting name' },
                                    { type: 'enhancement', message: 'Allow-/blocklist now have a clear button when selected' },
                                    { type: 'enhancement', message: 'Automatically reloading page data when page has been hidden for more then 5 minutes. This should resolve some of the issues where the insterfaces shows the wrong status/statistics' },
                                    { type: 'bug', message: 'Removed a css selector that causes problems in chrome 105 and newer' },
                                    { type: 'enhancement', message: 'New section/tab in servers where an overview of all interfaces cpu/memory/gpu usage is more visible' },
                                    { type: 'bug', message: 'Fixed some of the flickering in the interface filter' },
                                    { type: 'bug', message: 'Fixed a bugg when the client PC clock was out of sync with more then the statistics retain time, this caused the interfaces to flicker. The client clock still needs to be in sync for the user to see all stats.' },
                                    { type: 'feature', message: 'Added ping to the Settings page' },
                                    { type: 'feature', message: 'Added traceroute to the Settings page' },
                                ],
                            },
                            {
                                version: '1.5.0',
                                changes: [
                                    { type: 'enhancement', message: 'Changed version to 1.5.0' },
                                ],
                            },
                            {
                                version: '1.50b3',
                                changes: [
                                    { type: 'enhancement', message: 'Changed names of encryption options for SRT source and target' },
                                ],
                            },
                            {
                                version: '1.50b2',
                                changes: [
                                    { type: 'enhancement', message: 'Added support for setting FEC percentage for ZIXI target' },
                                    { type: 'enhancement', message: 'Added support for setting SSM source address on UDP target' },
                                    { type: 'enhancement', message: 'Server status page now show more information about the server' },
                                    { type: 'enhancement', message: 'Server status shows network buffer settings, RP Mode and selected system buffers' },
                                ],
                            },
                            {
                                version: '1.5.0b',
                                changes: [
                                    { type: 'feature', message: 'ZIXI Target (feeder) support added (BETA)' },
                                    { type: 'enhancement', message: 'NIC selection is added to ZIXI, RIST and SRT, "Show network bind options"' },
                                    { type: 'feature', message: 'Showing more server statistics, CPU Governor state, NIC Reverse Path Mode, network buffers and system buffers' },
                                    { type: 'feature', message: 'New services to handle OnDemand (CPU Governor) and Reverse Path filtering Off' },
                                    { type: 'feature', message: 'Initial code for new server status daemon (BETA)' },
                                    { type: 'feature', message: 'Zixi device ID settings' },
                                    { type: 'feature', message: 'New setting for how log statistics should be saved in the database' },
                                    { type: 'enhancement', message: 'Allow-/Blocklist now have a comment for each address' },
                                    { type: 'enhancement', message: 'Updated network configuration UI' },
                                    { type: 'enhancement', message: 'Packet bunching setting added to UI for each interface' },
                                ],
                            },
                            {
                                version: '0.9.10',
                                changes: [
                                    { type: 'feature', message: 'Added support for SRT Backup mode for Socket Groups (Multipathing)' },
                                    { type: 'enhancement', message: 'Experimental support for RTP reordering' },
                                ],
                            },
                            {
                                version: '0.9.9',
                                changes: [
                                    { type: 'feature', message: 'BISS1 decryption added' },
                                    { type: 'feature', message: 'New input type, ZIXI'},
                                    { type: 'feature', message: 'New output type, TimeShifter'},
                                    { type: 'feature', message: 'New output type, NDI' },
                                    { type: 'feature', message: 'SRT Relay added'},
                                    { type: 'feature', message: 'Added SRT mode setting and support for rendezvous' },
                                    { type: 'feature', message: 'Redundancy mode added to UDP target'},
                                    { type: 'enhancement', message: 'CPU load now show average load and the load of each core'},
                                    { type: 'feature', message: 'Each interface now shows average CPU and memory usage'},
                                    { type: 'feature', message: 'Server uptime visible in Settings'},
                                ],
                            },
                            {
                                version: '0.9.8',
                                changes: [
                                    { type: 'feature', message: 'HLS input added, RTMP input code updated and more stable'},
                                    { type: 'feature', message: 'Relay input added, one SRT input that can forward traffic using settings in streamid'},
                                    { type: 'feature', message: 'Timeshift output added, can delay a udp output up to x min'},
                                    { type: 'feature', message: 'Multiple outputs on one interface, you can mix protocols as you please'},
                                    { type: 'enhancement', message: 'Redundancy mode added to UDP output, uses named inputs "main" and "backup"'},
                                    { type: 'bug', message: 'Resolved some stats issues in UI, should handle timestamps better now'},
                                ],
                            },
                            {
                                version: '0.9.7',
                                changes: [
                                    { type: 'feature', message: 'GEO IP information for SRT connections'},
                                    { type: 'feature', message: 'Playlists added, compatible with VLC and Haivision Player Pro'},
                                    { type: 'feature', message: 'Interface start time is shown on each interface'},
                                    { type: 'feature', message: 'Hover on interface status includes interface uptime'},
                                    { type: 'feature', message: 'Summary for visible interfaces, includes number of connections and bandwidth'},
                                    { type: 'enhancement', message: 'UI performance enhanced, uses much less CPU and less memory'},
                                ],
                            },
                            {
                                version: '0.9.6',
                                changes: [
                                    { type: 'bug', message: 'Fixed bug where having multiple route inputs opened caused severe slowdowns'},
                                    { type: 'bug', message: 'Fixed bug where the chevron indication if an interface was opened or closed always showed closed (SUI-I5)'},
                                    { type: 'enhancement', message: 'Tags are now sorted by name in all components (SUI-I1)'},
                                    { type: 'enhancement', message: 'Massive speed enhancement, UI now flows much better with 64+ interfaces (SUI-I4)'},
                                    { type: 'feature', message: 'When filtering by tag you can stop/start/restart all interfaces with the selected tag (SUI-I3)'},
                                ],
                            },
                            {
                                version: '0.9.5',
                                changes: [
                                    { type: 'feature', message: 'Assign tags to interfaces and use them to filter the interface list'},
                                    { type: 'feature', message: 'Event notifications, will notify when interface start/stop and for SRT when they connect to a peer'},
                                    { type: 'feature', message: 'Current network settings are shown, editing is currently disabled'},
                                    { type: 'feature', message: 'New output type, "Multiple Outputs"'},
                                    { type: 'feature', message: 'SRT and UDP inputs can be populated from a list of available router sources'},
                                ],
                            },
                        ],
                    },
                    {
                        name: 'Interfaces',
                        versions: [
                            {
                                version: '1.6.4',
                                changes: [
                                    { type: 'bug', message: 'Fixed issue where interfaces using Zixi output sometimes leaked memory and eventually crashed' },
                                    { type: 'bug', message: 'Fixed issue where interfaces using Route input with nothing routed used 100% CPU' },
                                    { type: 'enhancement', message: 'Added loglevel for IDN Engine logs' },
                                    { type: 'enhancement', message: 'Support added for url encoded characters in passwords and settings' },

                                ],
                            },
                            {
                                version: '1.6.3',
                                changes: [
                                    { type: 'bug', message: 'Fixed issue where the route destination update could fail due to a compare bug' },
                                ],
                            },
                            {
                                version: '1.6.2',
                                changes: [
                                    { type: 'bug', message: 'Fixed issue where a unicast udp source crashed the route input' },
                                ],
                            },
                            {
                                version: '1.6.1',
                                changes: [
                                    { type: 'bug', message: 'Fixed issue where service status updates failed after a random time'},
                                ],
                            },
                            {
                                version: '1.6.0',
                                changes: [
                                    { type: 'enhancement', message: 'Updated SRT version to 1.5.1'},
                                    { type: 'enhancement', message: 'Change default connection limit to 1 from unlimited'},
                                    { type: 'feature', message: 'Added a lock for advanced features, this is to ensure that uses know that some changes may affect functionality if not used correctly'},
                                    { type: 'feature', message: 'Added a force stop command, hidden under advanced features. This will force stop the interface if a normal stop fails'},
                                    { type: 'enhancement', message: 'Changed how server status is collected, this will decrease CPU usage'},
                                    { type: 'enhancement', message: 'Changed how interfaces are started and stopped to increase system stability'},
                                    { type: 'enhancement', message: 'Changes to how services are monitored and controlled to increase system stability'},
                                    { type: 'feature', message: 'Uppdated support for SRT Socket groups aka multipathing to work with 1.5.1'},
                                    { type: 'enhancement', message: 'Fixed issue in statistics where SRT Socket groups statistics were unavailable'},
                                    { type: 'bug', message: 'Fixed bug in SRT statistics where the stats were generated to often and could show the wrong bitrate' },
                                ],
                            },
                            {
                                version: '1.5.0',
                                changes: [
                                    { type: 'enhancement', message: 'Changed version to 1.5.0' },
                                ],
                            },
                            {
                                version: '1.5.0b3',
                                changes: [
                                    { type: 'bug', message: 'Fixed bug in RIST source/target where statistics wasn\'t handled correctly' },
                                    { type: 'enhancement', message: 'Updated to latest version of librist' },
                                    { type: 'enhancement', message: 'Some changes to how rist connections are handled to increase stability of rist connections' },
                                    { type: 'enhancement', message: 'Some minor adjustments in how statistics is handled' },
                                    { type: 'enhancement', message: 'Added class name to logging, to make it clearer' },
                                ],
                            },
                            {
                                version: '1.5.0b2',
                                changes: [
                                    { type: 'enhancement', message: 'Added support for setting FEC percentage for ZIXI target' },
                                    { type: 'enhancement', message: 'Added support for setting SSM source address on UDP target' },
                                    { type: 'bug', message: 'Fixed error in boro.service that caused the recordings feature to be unavailable' },
                                ],
                            },
                            {
                                version: '1.5.0b',
                                changes: [
                                    { type: 'enhancement', message: 'Updated SRT version to 1.4.4'},
                                    { type: 'enhancement', message: 'Updated RIST version to 0.2.6-31'},
                                    { type: 'enhancement', message: 'Added support binding to NIC for SRT, RIST and Zixi' },
                                    { type: 'feature', message: 'Added Zixi Target (BETA)' },
                                    { type: 'enhancement', message: 'Changed RTMP input to in-process, no external processes needed' },
                                    { type: 'feature', message: 'Added Dummy Target So interface can be started to test just the input' },
                                    { type: 'feature', message: 'New logging of connected clients (BETA)' },
                                    { type: 'feature', message: 'Initial network configuration text-based UI' },
                                    { type: 'enhancement', message: 'Packet bunching added to suppress CPU usage on high bitrate streams'},
                                ],
                            },
                            {
                                version: '0.9.6',
                                changes: [
                                    { type: 'enhancement', message: 'Updated SRT version to 1.4.3'},
                                    { type: 'enhancement', message: 'Updated RIST version to 0.2.6'},
                                    { type: 'feature', message: 'Added support for SRT Backup mode for Socket Groups (Multipathing)' },
                                    { type: 'enhancement', message: 'Experimental support for RTP reordering' },
                                    { type: 'bug', message: 'Fixed CPU usage issue for UDP input' },
                                ],
                            },
                            {
                                version: '0.9.5',
                                changes: [
                                    { type: 'feature', message: 'BISS1 decryption added' },
                                    { type: 'feature', message: 'New input type, ZIXI'},
                                    { type: 'feature', message: 'New output type, TimeShifter'},
                                    { type: 'feature', message: 'New output type, NDI'},
                                    { type: 'feature', message: 'SRT Relay added'},
                                    { type: 'feature', message: 'Added SRT mode setting and support for rendezvous' },
                                    { type: 'feature', message: 'Redundancy mode added to UDP target'},
                                    { type: 'bug', message: 'Error Cinegy route integration code, would lock process if no multicast was available' },
                                    { type: 'bug', message: 'Fixed memory leak in RIST Source' },
                                ],
                            },
                            {
                                version: '0.9.2',
                                changes: [
                                    { type: 'bug', message: 'Sometimes the statistics showed the wrong values if bandwidth was lost without a disconnect' },
                                    { type: 'bug', message: 'Error in json generation of versions caused display error in UI' },
                                    { type: 'feature', message: 'Interface start time added' },
                                ],
                            },
                            {
                                version: '0.9.1b',
                                changes: [
                                    { type: 'feature', message: 'Notifications added for interface start/stop and SRT connections'},
                                    { type: 'feature', message: 'New output type, "Multiple Outputs"'},
                                    { type: 'feature', message: 'Added sources to route listner'},
                                    { type: 'enhancement', message: 'Bumped SRT version to 1.4.2'},
                                ],
                            },
                            {
                                version: '0.9.0b',
                                changes: [
                                    { type: 'info', message: 'Initial packet'},
                                ],
                            },
                        ],
                    },
                ],
            };
            resolve(changeLog);
        });
    }

    public GetProtocolFearureList(): any {
        return {
            srt : {
                Network: {
                    latency : {
                        input: true,
                        output: true,
                        type: 'number',
                        min: 0,
                        max: 'n/a',
                        default: 120,
                        unit: 'ms',
                        name: 'Latency',
                        advancedLock: false,
                    },
                    groupconnect : {
                        input: true,
                        output: true,
                        type: 'number',
                        min: 0,
                        max: 1,
                        default: 0,
                        unit: 'n/a',
                        name: 'Multipath',
                        advancedLock: false,
                    },
                    rtp : {
                        input: true,
                        output: false,
                        type: 'boolean',
                        min: 'n/a',
                        max: 'n/a',
                        default: false,
                        unit: 'n/a',
                        name: 'Add RTP',
                        advancedLock: false,
                    },
                    udp : {
                        input: false,
                        output: true,
                        type: 'boolean',
                        min: 'n/a',
                        max: 'n/a',
                        default: false,
                        unit: 'n/a',
                        name: 'Strip RTP',
                        advancedLock: false,
                    },
                },
                Security: {
                    passphrase: {
                        input: true,
                        output: true,
                        type: 'string',
                        min: 10,
                        max: 80,
                        default: '',
                        unit: 'n/a',
                        name: 'Passphrase',
                        advancedLock: false,
                    },
                    pbkeylen: {
                        input: true,
                        output: true,
                        type: 'dropdown',
                        min: 'n/a',
                        max: 'n/a',
                        default: 16,
                        unit: 'n/a',
                        name: 'Key length',
                        values: [
                            {
                                value: 16,
                                name: 'AES-128',
                            },
                            {
                                value: 24,
                                name: 'AES-192',
                            },
                            {
                                value: 32,
                                name: 'AES-256',
                            },
                        ],
                        advancedLock: false,
                    },
                },
                Advanced: {
                    'mode': {
                        input: true,
                        output: true,
                        type: 'dropdown',
                        min: 'n/a',
                        max: 'n/a',
                        default: '',
                        unit: 'n/a',
                        name: 'Mode',
                        values: [
                            {
                                value: '',
                                name: 'Auto',
                            },
                            {
                                value: 'caller',
                                name: 'Caller',
                            },
                            {
                                value: 'listener',
                                name: 'Listener',
                            },
                            {
                                value: 'rendezvous',
                                name: 'Rendezvous',
                            },
                        ],
                        advancedLock: false,
                    },
                    'rcvbuf' : {
                        input: true,
                        output: true,
                        type: 'number',
                        min: 46592 ,
                        max: 'n/a',
                        default: 12058624,
                        unit: 'Bytes',
                        name: 'Receive Buffers',
                        advancedLock: true,
                    },
                    'conntimeo' : {
                        input: true,
                        output: true,
                        type: 'number',
                        min: 0 ,
                        max: 'n/a',
                        default: 3000,
                        unit: 'ms',
                        name: 'Connection Timeout',
                        advancedLock: true,
                    },
                    'tlpktdrop' : {
                        input: true,
                        output: true,
                        type: 'boolean',
                        min: 'n/a',
                        max: 'n/a',
                        default: true,
                        unit: 'n/a',
                        name: 'Drop Old Packets',
                        advancedLock: true,
                    },
                    'streamid': {
                        input: true,
                        output: true,
                        type: 'string',
                        min: 0,
                        max: 512,
                        default: '',
                        unit: 'n/a',
                        name: 'Streamid',
                        advancedLock: false,
                    },
                    'type': {
                        input: true,
                        output: true,
                        type: 'dropdown',
                        min: 'n/a',
                        max: 'n/a',
                        default: 1,
                        unit: 'n/a',
                        name: 'Socket Group Type',
                        values: [
                            {
                                value: 1,
                                name: 'Broadcast (Active/Active)',
                            },
                            {
                                value: 2,
                                name: 'Backup (Active/Passive)',
                            },
                            {
                                value: 3,
                                name: 'Balancing N/A',
                            },
                        ],
                        advancedLock: true,
                    },
                    'maxbw': {
                        input: true,
                        output: true,
                        type: 'number',
                        min: -1 ,
                        max: 'n/a',
                        default: -1,
                        unit: 'bits/s',
                        name: 'Max Bitrate',
                        advancedLock: true,
                    },
                    'oheadbw': {
                        input: true,
                        output: true,
                        type: 'number',
                        min:  5,
                        max: 100,
                        default: 25,
                        unit: '%',
                        name: 'Bitrate Overhead',
                        advancedLock: true,
                    },
                    'bt-loglevel': {
                        input: true,
                        output: true,
                        type: 'dropdown',
                        min: 'n/a',
                        max: 'n/a',
                        default: 1,
                        unit: 'n/a',
                        name: 'Socket Group Type',
                        values: [
                            {
                                value: 2,
                                name: 'Critical',
                            },
                            {
                                value: 3,
                                name: 'Error',
                            },
                            {
                                value: 4,
                                name: 'Warn',
                            },
                            {
                                value: 5,
                                name: 'Notice',
                            },
                            {
                                value: 6,
                                name: 'Info',
                            },
                            {
                                value: 7,
                                name: 'Debug',
                            },
                        ],
                        advancedLock: true,
                    },
                },
            },
        };
    }

    public GetInterfaces(): Promise<IInterface[]> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.get('/api/interfaces/')
            .then((response: any) => {
                resolve(response.data as IInterface[]);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public GetStatus(lastTimestamp: string|null): Promise<IStatus[]> {
        return new Promise((resolve, reject) => {
           // resolve(mock_status);
           axios.get(`/api/statistics/?timestamp=${lastTimestamp === undefined ? '' : lastTimestamp}`)
           .then((response: any) => {
               resolve(response.data as IStatus[]);
           }, (err: any) => {
               reject(err);
           });
        });
    }

    public GetAllowBlockList(): Promise<IAllowBlockList[]> {
        return new Promise((resolve, reject) => {
           // resolve(mock_status);
           axios.get(`/api/allow_block_list/`)
           .then((response: any) => {
               resolve(response.data as IAllowBlockList[]);
           }, (err: any) => {
               reject(err);
           });
        });
    }

    public AddAllowBlockList(value: IAllowBlockList): Promise<void> {
        return new Promise((resolve, reject) => {
           // resolve(mock_status);
           axios.put(`/api/allow_block_list/`, value)
           .then((response: any) => {
               resolve();
           }, (err: any) => {
               reject(err);
           });
        });
    }

    public GetAccessControl(): Promise<IAccessControl[]> {
        return new Promise((resolve, reject) => {
           // resolve(mock_status);
           axios.get(`/api/access_control/`)
           .then((response: any) => {
               resolve(response.data as IAccessControl[]);
           }, (err: any) => {
               reject(err);
           });
        });
    }

    public async AddAccessControl(value: IAccessControl): Promise<void> {
        return new Promise((resolve, reject) => {
           // resolve(mock_status);
           axios.put(`/api/access_control/`, value)
           .then((response: any) => {
               resolve();
           }, (err: any) => {
               reject(err);
           });
        });
    }

    public GetNetworkConfig(): Promise<INetwork> {
        return new Promise((resolve, reject) => {
           // resolve(mock_status);
           axios.get(`/api/network/`)
           .then((response: any) => {
               resolve(response.data as INetwork);
           }, (err: any) => {
               reject(err);
           });
        });
    }

    public SaveNetworkInterface( inet: INetworkInterfaceHelper): void {
        window.console.log('SaveNic');
        window.console.log(inet);
        axios.post(`/api/network/?action=save`, inet);
        window.console.log('done savenic');
    }

    public AddVLAN( inet: INetworkInterfaceHelper): void {
        axios.post(`/api/network/?action=addvlan`, inet);
    }

    public DelVLAN( inet: INetworkInterfaceHelper): void {
        axios.post(`/api/network/?action=delvlan`, inet);
    }

    public GetPlaylists(): Promise<IPlaylist[]> {
        return new Promise((resolve, reject) => {
           // resolve(mock_status);
           axios.get(`/api/playlists/`)
           .then((response: any) => {
               resolve(response.data as IPlaylist[]);
           }, (err: any) => {
               reject(err);
           });
        });
    }

    public async Reboot(): Promise<void> {
        await axios.post(`/api/server/?action=reboot`);
    }

    public async StartInterface(id: string, nr: number): Promise<void> {
        await axios.post(`/api/interfaces/?action=start&id=${id}&nr=${nr}`);
    }

    public async StopInterface(id: string, nr: number): Promise<void> {
        await axios.post(`/api/interfaces/?action=stop&id=${id}&nr=${nr}`);
    }

    public async ForceStopInterface(id: string, nr: number): Promise<void> {
        await axios.post(`/api/interfaces/?action=forcestop&id=${id}&nr=${nr}`);
    }

    public async RestartInterface(id: string, nr: number): Promise<void> {
        await axios.post(`/api/interfaces/?action=restart&id=${id}&nr=${nr}`);
    }

    public SaveInterface(inter: IInterface): void {
        axios.post(`/api/interfaces/?action=save&id=${inter.id}`, inter);
    }

    public SaveAllowBlockList(list: IAllowBlockList): void {
        axios.post(`/api/allow_block_list/?id=${list.id}`, list);
    }

    public DeleteAllowBlockList(list: IAllowBlockList): void {
        axios.delete(`/api/allow_block_list/?id=${list.id}`);
    }

    public SaveAccessControl(list: IAccessControl): void {
        axios.post(`/api/access_control/?id=${list.id}`, list);
    }

    public DeleteAccessControl(list: IAccessControl): void {
        axios.delete(`/api/access_control/?id=${list.id}`);
    }

    public GetCinegyRouteDestinations(): Promise<string[]> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.get('/api/cinegy_route/?action=destinations')
            .then((response: any) => {
                const ret: string[] = [];
                for (const i of response.data) {
                    ret.push(i.id);
                }
                resolve(ret);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public GetGeoIP(ip: string): Promise<IGeoIP> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.get(`/api/geo_ip/?ip=${ip}`)
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public GetCinegyRouteSources(): Promise<ICinegyRouteSource[]> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.get('/api/cinegy_route/?action=sources')
            .then((response: any) => {
                resolve(response.data as ICinegyRouteSource[]);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public GetRecordings(): Promise<IRecording[]> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.get('/api/recordings/')
            .then((response: any) => {
                const ret: IRecording[] = [];
                for (const i of response.data) {
                    ret.push({ name: decodeURI(i.name), files: i.files });
                }
                resolve(ret);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public GetLicenses(): Promise<ILicences> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.get('/api/licencing/')
            .then((response: any) => {
                const ret: ILicences = {
                                            srt: false,
                                            rist: false,
                                            rtmp: false,
                                            hls: false,
                                            cinegy_route: false,
                                            capture_playback: false,
                                            relay: false,
                                            tudp: false,
                                            zixi: false,
                                            biss: false,
                                            ndi: false,
                                            interfaces: 0,
                                            multi_output: false,
                                            trial: false,
                                            trial_end_date: undefined,
                                        };
                // ret = response.data;

                if (response.data.hasOwnProperty('srt')) {
                    ret.srt = response.data.srt;
                }

                if (response.data.hasOwnProperty('rist')) {
                    ret.rist = response.data.rist;
                }

                if (response.data.hasOwnProperty('rtmp')) {
                    ret.rtmp = response.data.rtmp;
                }

                if (response.data.hasOwnProperty('hls')) {
                    ret.hls = response.data.hls;
                }

                if (response.data.hasOwnProperty('cinegy_route')) {
                    ret.cinegy_route = response.data.cinegy_route;
                }

                if (response.data.hasOwnProperty('capture_playback')) {
                    ret.capture_playback = response.data.capture_playback;
                }

                if (response.data.hasOwnProperty('interfaces')) {
                    ret.interfaces = response.data.interfaces;
                }

                if (response.data.hasOwnProperty('multi_output')) {
                    ret.multi_output = response.data.multi_output;
                }

                if (response.data.hasOwnProperty('relay')) {
                    ret.relay = response.data.relay;
                }

                if (response.data.hasOwnProperty('tudp')) {
                    ret.tudp = response.data.tudp;
                }

                if (response.data.hasOwnProperty('zixi')) {
                    ret.zixi = response.data.zixi;
                }

                if (response.data.hasOwnProperty('biss')) {
                    ret.biss = response.data.biss;
                }

                if (response.data.hasOwnProperty('trial')) {
                    ret.trial = response.data.trial;
                }

                if (response.data.hasOwnProperty('trial_end_date')) {
                    ret.trial_end_date = response.data.trial_end_date;
                }

                resolve(ret);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public LicenceRequest(request: ILicences): Promise<ILicenceRequest> {
        return new Promise((resolve, reject) => {
            axios.post('/api/licencing/?action=request', request)
            .then((response: any) => {
                let ret: ILicenceRequest = {
                                            key: '',
                                            signature: '',
                                        };
                ret = response.data;

                resolve(ret);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public LicenceReponse(request: ILicenceResponce): Promise<ILicences> {
        return new Promise((resolve, reject) => {
            axios.post('/api/licencing/?action=response', request)
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async GetServices(): Promise<IService> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.get('/api/services/')
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async EnableService(service: string): Promise<IService> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.post(`/api/services/?service=${service}&action=enable`)
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async DisableService(service: string): Promise<IService> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.delete(`/api/services/?service=${service}&action=disable`)
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async StartService(service: string): Promise<IService> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.post(`/api/services/?service=${service}&action=start`)
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async StopService(service: string): Promise<IService> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.delete(`/api/services/?service=${service}&action=stop`)
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async ExecuteCommand(command: string, address: string, nic: string): Promise<ICommand> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.post(`/api/server/?action=${command}&address=${address}&nic=${nic}`)
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async CheckCommandStatus(id: string): Promise<ICommandResponse> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.get(`/api/server/?action=commandStatus&id=${id}`)
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async GetSettings(): Promise<ISetting> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.get('/api/settings/')
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async SaveSetting(setting: ISetting): Promise<ISetting> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.post(`/api/settings/?key=${setting.key}&value=${setting.value}`)
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async GetBoroSettings(): Promise<IBoroSettings> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.get('/api/probe/')
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async SaveBoroSettings(settings: IBoroSettings): Promise<IBoroSettings> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.post('/api/probe/', settings)
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async GetVersions(): Promise<IVersions> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.post('/api/versions/')
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async GetServerStatus(): Promise<IServer> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.get('/api/server/')
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async GetStatisticsSummary(): Promise<IStatisticsSummary> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.post('/api/statistics_summaries/')
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async GetTags(): Promise<ITag[]> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.get('/api/tag/')
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async AddTag(tag: ITag): Promise<ITag[]> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.post('/api/tag/', tag)
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async UpdateTag(tag: ITag): Promise<ITag[]> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.put('/api/tag/', tag)
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async RemoveTag(tag: ITag): Promise<ITag[]> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.delete(`/api/tag/?id=${tag.id}`)
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async AddPlaylist(playlist: IPlaylist): Promise<boolean> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.post('/api/playlists/', playlist)
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async UpdatePlaylist(playlist: IPlaylist): Promise<boolean> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.put('/api/playlists/', playlist)
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async RemovePlaylist(tag: IPlaylist): Promise<boolean> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.delete(`/api/playlists/?id=${tag.id}`)
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async GetEvents(timestamp: string|undefined, page: number|undefined = 0): Promise<IEvent[]> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.get(`/api/events/?timestamp=${timestamp}&page=${page}`)
            .then((response: any) => {
                resolve(response.data);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    public async GetEventCount(): Promise<number> {
        // @ts-ignore
        return new Promise((resolve, reject) => {
            axios.get(`/api/events/?action=count`)
            .then((response: any) => {
                resolve(response.data.nr);
            }, (err: any) => {
                reject(err);
            });
         });
    }

    /*private ToInterface(interfaces: IInterface[]): Interface[] {
        let ret: Interface[] = [];
        ret = [];
        for (const i of interfaces) {
            ret.push(new Interface(i));
        }

        return ret;
    }*/

    /*private ToStatus(statuses: IStatus[]): Status[] {
        let ret: Status[] = [];
        ret = [];
        for (const i of statuses) {
            ret.push(new Status(i));
        }

        return ret;
    }*/

}

export default new APIService();
